import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import logo from "@/assets/images/logo.svg";
import { APP_NAME } from "@/constants/common";
import { black } from "@/theme/colors";

type TLoginLogoProps = {};

export const LoginLogo: FC<TLoginLogoProps> = () => {
  return (
    <Stack gap={1} alignItems="center">
      <Stack>
        <img width={240} src={logo} alt="logo" />
      </Stack>
      <Stack alignItems="center" width={240} paddingY={1} bgcolor={black[30]}>
        <Typography variant="sub16Bold" color="white">
          {APP_NAME}│システム管理
        </Typography>
      </Stack>
    </Stack>
  );
};
